import React from 'react'

import CompanyTypeIcon from '@/components/misc/CompanyIcon/CompanyTypeIcon'
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import useAppSelector from '@/hooks/useAppSelector'
import { useAuth } from '@/hooks/useAuth'
import { useUserGroups } from '@/hooks/useUserGroups'
import { isDevelopment } from '@/lib/helpers/envHelpers'
import { truncateText } from '@/lib/helpers/helperFunctions'
import { cn } from '@/lib/utils'
import { selectCurrentGroup } from '@/redux/slices/session'

const UserGroups: React.FC = () => {
  const currentGroup = useAppSelector(selectCurrentGroup)
  const groups = useUserGroups()
  const { updateGroupContext } = useAuth()

  if (!groups.length) {
    return null
  }

  return (
    <>
      <DropdownMenuLabel>Group</DropdownMenuLabel>

      {groups.map((group) => (
        <DropdownMenuItem
          onClick={() => updateGroupContext({ group: group['@id'] })}
          key={group.id}
          title={isDevelopment() ? `ID: ${group.id.toString()}` : undefined}
          className={cn({
            'bg-accent': group.id === currentGroup?.id,
          })}
        >
          <CompanyTypeIcon
            companyTypeCode="other"
            style={{ width: '16px', height: '16px' }}
          />

          {truncateText(group.name, { maxLength: 50 })}
        </DropdownMenuItem>
      ))}

      <DropdownMenuSeparator />
    </>
  )
}

export default UserGroups
